import type { ViewStyle } from 'react-native'

/**
 * Apple's continuous ("squircle") corner — Figma's 60% corner smoothing — for a
 * control of this corner radius and height.
 *
 * - Only for a corner that leaves a straight edge to curve into: at half the
 *   height the radius already draws a stadium or a circle, and smoothing those
 *   ends flattens them instead of softening them.
 */
export function cornerCurve(
  radius: number,
  height: number,
): ViewStyle['borderCurve'] {
  return radius < height / 2 ? 'continuous' : 'circular'
}
